var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9879 12.8714C9.77927 14.6403 6.54641 14.5011 4.49909 12.4538C2.30239 10.2571 2.30239 6.69554 4.49909 4.49884C6.69579 2.30214 10.2574 2.30214 12.454 4.49884C14.5014 6.54616 14.6406 9.77901 12.8717 11.9876L17.1681 16.2839C17.4122 16.528 17.4122 16.9238 17.1681 17.1678C16.924 17.4119 16.5283 17.4119 16.2842 17.1678L11.9879 12.8714ZM5.38297 11.5699C3.67443 9.86134 3.67443 7.09127 5.38297 5.38273C7.09152 3.67418 9.8616 3.67418 11.5702 5.38273C13.2774 7.09002 13.2787 9.85726 11.5739 11.5662C11.5727 11.5674 11.5714 11.5686 11.5701 11.5699C11.5689 11.5712 11.5676 11.5724 11.5664 11.5737C9.85752 13.2784 7.09026 13.2772 5.38297 11.5699Z",
    fill: "#6130B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilled);
export default __webpack_public_path__ + "static/media/search-filled.00780f03bac5a551edb63b50273e69f4.svg";
export { ForwardRef as ReactComponent };